/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
import {NgModule} from '@angular/core';
import {ReleaseAuthorizationService} from './release-authorization.service';

@NgModule({
    providers: [ReleaseAuthorizationService]
})
export class ReleaseAuthorizationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/release/release-authorization.module.ts